import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { WARNING_TEXT, DARK_GREEN_TEXT, LATE_LONG_COLOR, ERROR_TEXT, DARK_TEXT } = COLORS;

interface StyleProps {
  color?:
    | 'primary'
    | 'mainGrey'
    | 'lightGrey'
    | 'darkGrey'
    | 'darkGreen'
    | 'warningTime'
    | 'warning'
    | 'errorText'
    | 'darkText';
  fontSize?: number;
  variant?: 'heading' | 'subHeading' | 'text';
}
export const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    baseStyle: {
      color: ({ color }) => {
        const colorMap = {
          primary: theme.palette.primary.main,
          lightGrey: theme.palette.customGrey.light,
          mainGrey: theme.palette.customGrey.main,
          darkGrey: theme.palette.customGrey.dark,
          darkGreen: DARK_GREEN_TEXT,
          warning: WARNING_TEXT,
          warningTime: LATE_LONG_COLOR,
          errorText: ERROR_TEXT,
          darkText: DARK_TEXT,
        };
        return color ? colorMap[color] : undefined;
      },
      fontSize: ({ variant }) => {
        if (variant === 'heading') {
          return 24;
        } else if (variant === 'subHeading') {
          return 20;
        }
        return 16;
      },
      fontWeight: ({ variant }) => {
        if (variant === 'heading') {
          return 700;
        } else if (variant === 'subHeading') {
          return 500;
        }
        return 400;
      },
      wordBreak: 'break-word',
    },
  }),
);
